import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Home from "@/pages/Home";
import Creator from "@/pages/Creator";
import LavoraConNoi from "@/pages/LavoraConNoi";
import MetodoPrivacy from "@/pages/MetodoPrivacy";
import ChiSiamo from "@/pages/ChiSiamo";
import PartnershipDopamine from "@/pages/PartnershipDopamine";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import Faq from "@/pages/Faq";
import Admin from "@/pages/Admin";

export default function AppRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <motion.main
        key={location.pathname}
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -16 }}
        transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
        data-testid="page-transition-wrapper"
      >
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/creator" element={<Creator />} />
          <Route path="/lavora-con-noi" element={<LavoraConNoi />} />
          <Route path="/metodo-privacy" element={<MetodoPrivacy />} />
          <Route path="/chi-siamo" element={<ChiSiamo />} />
          <Route path="/partnership-dopamine" element={<PartnershipDopamine />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </motion.main>
    </AnimatePresence>
  );
}
